module.exports = __webpack_public_path__ + "img/mp-solution-icon-7.139a7f37.png";